import { render, staticRenderFns } from "./updatecompanyname.vue?vue&type=template&id=78133e40&scoped=true"
import script from "./updatecompanyname.vue?vue&type=script&lang=js"
export * from "./updatecompanyname.vue?vue&type=script&lang=js"
import style0 from "./updatecompanyname.vue?vue&type=style&index=0&id=78133e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78133e40",
  null
  
)

export default component.exports